import { useQuote } from "@/context/QuoteContext";

export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-2 rounded-md bg-[#1E5EDB] px-6 py-3 font-display text-[14px] font-bold tracking-wide text-white transition-colors hover:bg-[#1A52C2]";
export const BTN_OUTLINE =
  "inline-flex items-center justify-center gap-2 rounded-md border-2 border-[#1E5EDB] px-6 py-3 font-display text-[14px] font-bold tracking-wide text-[#1E5EDB] transition-colors hover:bg-[#1E5EDB] hover:text-white";
export const BTN_WHITE =
  "inline-flex items-center justify-center gap-2 rounded-md bg-white px-6 py-3 font-display text-[14px] font-bold tracking-wide text-[#1E5EDB] transition-transform hover:-translate-y-0.5";

export const SectionHeading = ({ eyebrow, title, align = "center", light = false, className = "" }) => (
  <div className={`${align === "center" ? "text-center" : "text-left"} ${className}`}>
    {eyebrow && (
      <p className="font-display text-[13px] font-bold uppercase tracking-[0.22em] text-[#1E5EDB]">{eyebrow}</p>
    )}
    <h2 className={`font-display text-3xl sm:text-4xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#0A2342]"}`}>
      {title}
    </h2>
    <span className={`mt-4 inline-block h-1 w-16 rounded-full bg-[#1E5EDB] ${align === "center" ? "" : ""}`} />
  </div>
);

export const CtaBand = ({ icon: Icon, title, text, buttonLabel = "GET A QUOTE", note = "Fast response. No obligation." }) => {
  const { openQuote } = useQuote();
  return (
  <section className="mx-auto max-w-[1200px] px-5 lg:px-8 pb-20">
    <div className="flex flex-col items-start gap-6 rounded-2xl bg-[#F4F7FB] p-8 md:flex-row md:items-center md:justify-between md:p-10">
      <div className="flex items-start gap-5">
        <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full border-2 border-[#1E5EDB]/30">
          <Icon size={30} className="text-[#1E5EDB]" />
        </span>
        <div>
          <h3 className="font-display text-2xl font-extrabold text-[#0A2342]">{title}</h3>
          <p className="mt-1 max-w-md text-[15px] text-[#5B6B7F]">{text}</p>
        </div>
      </div>
      <div className="flex flex-col items-start gap-2 md:items-end">
        <button onClick={openQuote} data-testid="cta-quote-btn" className={BTN_PRIMARY}>{buttonLabel}</button>
        <span className="text-[13px] text-[#5B6B7F]">{note}</span>
      </div>
    </div>
  </section>
  );
};
